//@ts-check
import request from '../request';
/**
 * Returns a list with all versions of the specified input path
 * @param {string} workspace
 * @param {string} path
 * @return {Promise<Array<import('./types').FormDataVersion>>}
 */

var getFormVersions = function getFormVersions(workspace, path) {
  return request({
    url: '/backend/formversions',
    query: {
      workspace: workspace,
      path: path
    }
  });
};
/**
 * Return the content of the specified form from repository
 * @param {string} workspace
 * @param {string} path
 * @returns {Promise<string>}
 */


var getFormContent = function getFormContent(workspace, path) {
  return request({
    url: "/backend/forms",
    query: {
      workspace: workspace,
      path: path
    }
  });
};
/**
 * Process a specified form content by resolving references, contact fields, id's
 * The process is made using a backend API, the same used by the 'getFormContent' function
 * @param {string} workspace
 * @param {string} path
 * @param {string} content
 * @return {Promise<string>}
 */


var loadFormContent = function loadFormContent(workspace, path, content) {
  return request({
    url: '/backend/forms',
    method: 'POST',
    contentType: 'json',
    query: {
      workspace: workspace,
      path: path
    },
    data: JSON.stringify(content)
  });
};

export default {
  getFormVersions: getFormVersions,
  getFormContent: getFormContent,
  loadFormContent: loadFormContent
};